import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
import mergeOptions from '../lib/merge-options';

import './slick-carousel';
import 'jquery-zoom';
import createCounter from './slick/counter';
// Expose the function as a jQuery plugin for ease of use
export const PLUGIN_NAME = 'slides';

export const SLICK_CLASS = 'js-slides-slick';
export const STATUS_CLASS = 'js-slides-status';

export const DEFAULTS = {
  slidesToShow: 1,
  showStatus: true,
  lazyLoad: 'ondemand',
  arrows: true,
  delay: 1000,
  showZoomTab: false,
  productZoomBtn: '.product-zoom__btn',
  productZoomBtnActive: 'product-zoom__btn--active'
};

const zoomHover = ($zoomContainer, opts) => {
  const zoomImg = '.zoomImg';
  const delay = opts.delay;
  const hideClass = 'u-hide';
  let timer;
  $zoomContainer.hover(function () {
    timer = setTimeout(function () {
      $zoomContainer.find(zoomImg).removeClass(hideClass);
    }, delay);
  }, function () {
    clearTimeout(timer);
    $zoomContainer.find(zoomImg).addClass(hideClass);
  });
}

const initZoom = ($slidesWrap, opts) => {
  const $zoomContainer = $slidesWrap.find('.slick-active').find('.js-pdp-image-zoom');
  const zoomImgUrl = $zoomContainer.data('zoom-img');
  const hasActiveClass = $zoomContainer.hasClass('zoom-active');

  if (!hasActiveClass) {
    $zoomContainer.zoom({
      url: zoomImgUrl,
      callback: function () {
        $(this).addClass('u-hide');
      }
    });
    $zoomContainer.addClass('zoom-active');
  }
  zoomHover($zoomContainer, opts);
}

const getPaginationDotByIndex = ($dotsContainer, index) => {
  const selectedPaginationDot = $dotsContainer.find('li')[index];
  return $(selectedPaginationDot);
}

const setUpPagination = (slick, $slides) => {
  const activeClass = 'slick-dot-active';
  const $dotsContainer = slick.$dots;

  getPaginationDotByIndex($dotsContainer, 0).next().addClass(activeClass);
  $slides.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
    $dotsContainer.find('li').removeClass(activeClass);
    const slideToUpdate = nextSlide == slick.slideCount - 1 ? 0 : nextSlide + 1;
    if (currentSlide === nextSlide) {
      getPaginationDotByIndex($dotsContainer, slideToUpdate).addClass(activeClass);
    } else if (currentSlide < nextSlide || (currentSlide == slick.slideCount - 1 && nextSlide == 0)) {
      getPaginationDotByIndex($dotsContainer, slideToUpdate).addClass(activeClass);
    } else if (currentSlide > nextSlide) {
      getPaginationDotByIndex($dotsContainer, (nextSlide + 1)).addClass(activeClass);
    }
  });
}

const resetPaginationBreakpoint = (slick, $slides) => {
  $slides.on('breakpoint', (event, slick, breakpoint) => {
    if(breakpoint === null) {
      setUpPagination(slick, $slides);
    }
  })
}

const checkForPagination = ($slides) => {
  $slides
    .on('init', (event, slick) => {
      const showPagination = slick.$slides.length >= slick.options.slidesToShow;
      const hasPagination = slick.$dots != null;

      if (hasPagination && showPagination) {
        setUpPagination(slick, $slides);
        resetPaginationBreakpoint(slick, $slides)
      }
    })
}




const triggerZoom = ($slidesWrap, $slides, opts) => {
  $slides
    .on('init', (event, slick, currentSlide, nextSlide) => {
      initZoom($slidesWrap, opts)
      a11yKeyboardTriggerZoom($slidesWrap);
    })
    .on('afterChange', (event, slick, currentSlide, nextSlide) => {
      initZoom($slidesWrap, opts);
      a11yKeyboardTriggerZoom($slidesWrap);
    });
}

const a11yKeyboardTriggerZoom = ($slidesWrap) => {
  $slidesWrap.find('.pdp__image').removeAttr('tabindex');
  $slidesWrap.find('.slick-active .pdp__image').attr('tabindex', '0');
}

const initSlick = ($slidesWrap, $slides, opts) => {
  if (opts.showStatus) {
    createCounter($slidesWrap);
  }
  if (!$('html').hasClass('touch') && opts.zoomImg) {
    triggerZoom($slidesWrap, $slides, opts);
  }
  checkForPagination($slides);
  $slides.slick(opts);
}

/**
  * remove active class to hide btn
  */
const hideBtn = (opts) => {
  $(opts.productZoomBtn).removeClass(opts.productZoomBtnActive);
  $(opts.productZoomBtn).one('transitionend', () => {
    $(opts.productZoomBtn).hide();
  });
}

/**
  * add active class to show btn
  */
const showBtn = (opts) => {
  $(opts.productZoomBtn).addClass(opts.productZoomBtnActive);
}

/**
  * show and hide button on load
  */
const toggleProductZoomBtn = (opts) => {
  showBtn(opts);
  setTimeout(function () {
    hideBtn(opts);
  }, 1500);
}

/**
 * Initializes slides
 * @param {HTMLElement} el - tab link
 * @param {Object} [options] - Object containing override options
 */
export default function slides(el, options = {}) {
  const $slidesWrap = $(el);
  const $slides = $slidesWrap.find(`.${SLICK_CLASS}`);
  const opts = mergeOptions(DEFAULTS, options, $slidesWrap);
  initSlick($slidesWrap, $slides, opts);
  if (opts.showZoomTab) {
    toggleProductZoomBtn(opts);
  }
}

registerJQueryPlugin(PLUGIN_NAME, slides);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/slides.js